

























































































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import MasterMainteTab from "../../components/MasterMainteTab.vue"
import { BTable } from 'bootstrap-vue';
import { SearchCondition, BaseSheet } from "../../modules/teacher/BaseSheetList"

export interface Data {
  condition: SearchCondition
  baseSheets: BaseSheet[]
  fields: any[]
  perPage: number
  isAllDeleteChecked: boolean
  isShow: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "master-mainte-tab": MasterMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.baseSheetListCondition,
      baseSheets: new Array<BaseSheet>(),
      fields: [
        {key: "event_code", label: "イベント", sortable: true, class: 'text-center b-table-th-td'},
        {key: "sheet_code", label: "試験CD", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", sortable: true, class: 'text-center b-table-th-td'},
        {key: "month", label: "実施月", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "curriculum_id", label: "教科", sortable: true, class: 'text-center b-table-th-td'},
        {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        {key: "level", label: "VSH", sortable: true, class: 'text-center b-table-th-td'},
        {key: "field_names_completed_text", label: "設問情報", class: 'text-center b-table-th-td'},
        {key: "corretct_image_completed_text", label: "模範解答", class: 'text-center b-table-th-td'},
        {key: "score_positions_completed_text", label: "枠設定", class: 'text-center b-table-th-td'},
        {key: "explanation_image_completed_text", label: "解説PDF", class: 'text-center b-table-th-td'},
        {key: "question_image_completed_text", label: "問題PDF", class: 'text-center b-table-th-td'},
        {key: "part1_image_completed_text", label: "大問Png", class: 'text-center b-table-th-td'},
        {key: "status", label: "状態", class: 'text-center b-table-th-td'},
        {key: "edit", label: "設定", class: 'text-center b-table-th-td'},
      ],
      perPage: 20,
      isAllDeleteChecked: false,
      isShow: false,
      errors: [],
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.currentPage = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/base_sheet_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.baseSheets = response.data.base_sheet_hashes.map((x: any) => new BaseSheet(x)); 
        context.root.$store.commit("setBaseSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };

    /******************************
     * 採点設定画面へ
     ******************************/

    const saitenSettingClick = (baseSheet: BaseSheet) => {
      // 採点設定の進捗により遷移先を制御
      if (!baseSheet.field_names_completed) {
        context.root.$router.push(`/teacher_site/field_edit/${baseSheet.id}`).catch(err => {});
        return;
      }
      if (!baseSheet.corretct_image_completed) {
        context.root.$router.push(`/teacher_site/correct_image_upload/${baseSheet.id}`).catch(err => {});
        return;
      }
      if (!baseSheet.field_positions_completed) {
        context.root.$router.push(`/teacher_site/position_edit/${baseSheet.id}`).catch(err => {});
        return;
      }
      if (!baseSheet.score_positions_completed) {
        context.root.$router.push(`/teacher_site/score_position_edit/${baseSheet.id}`).catch(err => {});
        return;
      }
      if (!baseSheet.explanation_image_completed) {
        context.root.$router.push(`/teacher_site/explanation_pdf_upload/${baseSheet.id}`).catch(err => {});
        return;
      }
      if (!baseSheet.question_image_completed) {
        context.root.$router.push(`/teacher_site/question_pdf_upload/${baseSheet.id}`).catch(err => {});
        return;
      }
      context.root.$router.push(`/teacher_site/daimon_upload/${baseSheet.id}`).catch(err => {});
    };

    /******************************
     * 試験削除
     ******************************/

    const deletebaseSheets = async (): Promise<void> => {

      if(state.baseSheets.filter(x => x.is_checked).length == 0){
        alert("削除対象試験が選択されていません。");
        return;
      }

      if(!window.confirm("選択している試験を削除します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      // TODO 杉浦 削除のキーはidにするか、sheet_codeにするか？
      const delete_ids: number[] = state.baseSheets.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/base_sheet_list/delete_base_sheets`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");

      search();
    };

    /******************************
     * ページ内の試験全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: BaseSheet) => x.is_checked = isChecked);
    };

    /******************************
     * ページ切り替え
     ******************************/

    const pageChanged = () => {
      state.isAllDeleteChecked = false;
      state.baseSheets.forEach(x => x.is_checked = false);
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      if(context.root.$store.getters.isAdmin){
        state.fields.push({key: "delete", label: "削除", class: 'text-center'});
      }
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      searchClick,
      search,
      clearCondition,
      saitenSettingClick,
      deletebaseSheets,
      allSelectChanged,
      pageChanged,
    };
  }
});
